import * as React from "react";
import {FC} from "react";
import styles = require("./instanceEnvironmentVariableValue.less");


const InstanceEnvironmentVariableValue: FC<{value: string}> = (props) => <span className={styles.value}>{props.value}</span>;

export default InstanceEnvironmentVariableValue;